const PageLoginTrayCheck = () => import('./PageLoginTrayCheck');

export default {
  path: '/tray/callback',
  name: 'trayCheck',
  component: PageLoginTrayCheck,
  meta: {
    title: 'Checando login...',
  },
};



// WEBPACK FOOTER //
// ./src/features/public/login/tray-check/routes.js